import { Controller } from "@hotwired/stimulus"

// Table of contents on a doc page. Marks the link for the heading currently
// being read: the last heading that has scrolled past a line just below the
// floating nav. Recomputed on scroll (throttled to one per frame) rather than
// with an IntersectionObserver, because a short section can sit entirely
// between two headings with neither of them on screen.
export default class extends Controller {
	static targets = ["link"]
	static values = { offset: { type: Number, default: 140 } }

	connect() {
		this.headings = this.linkTargets
			.map((link) => document.getElementById(decodeURIComponent(link.hash.slice(1))))
			.filter(Boolean)
		this.onScroll = () => {
			if (this.frame) return
			this.frame = requestAnimationFrame(() => {
				this.frame = null
				this.update()
			})
		}
		window.addEventListener("scroll", this.onScroll, { passive: true })
		this.update()
	}

	disconnect() {
		window.removeEventListener("scroll", this.onScroll)
		if (this.frame) cancelAnimationFrame(this.frame)
	}

	update() {
		let current = this.headings[0]
		for (const heading of this.headings) {
			if (heading.getBoundingClientRect().top - this.offsetValue <= 0) current = heading
		}
		// At the very bottom the last headings can never reach the line, so the
		// final one wins once the page can't scroll further.
		if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) {
			current = this.headings[this.headings.length - 1]
		}

		this.linkTargets.forEach((link) => {
			const active = current && link.hash === `#${encodeURIComponent(current.id)}`
			link.classList.toggle("pp-toc-active", active)
			if (active) link.setAttribute("aria-current", "location")
			else link.removeAttribute("aria-current")
		})
	}
}
